const CITY_SELECTED_COOKIE         = "city_selected_v1";
const CITY_SELECTED_COOKIE_EXPIRES = 10000;

export default class CityDropdown {
    constructor(root, options) {
        this.root = root;
        if (!this.root) return;
        this.links = [...this.root.querySelectorAll("[data-city-dropdown-link]")];
        this._init();
    }

    _init() {
        if (this._isFirstVisit()) {
            const currentCityId = $.cookie('CURRENT_CITY_ID');
            $.removeCookie('current_region');
            $.cookie('current_region', currentCityId, {path: '/',domain: arNextOptions['MAIN_DOMAIN']});
        }
		
        this.links.forEach((link) => {
            link.addEventListener("click", (e) => {
                e.preventDefault();
                const $link = $(e.target)
                const cityId = $link.data("id");
                const url = $link.data("url");
                $.removeCookie('current_region');
                $.cookie('current_region', cityId, {path: '/',domain: arNextOptions['MAIN_DOMAIN']});
                $.ajax({
                    type: "POST",
                    url : arNextOptions['SITE_DIR'], //location.href,
                    data: {city: cityId},
                    success: function () {
                        $.cookie('basket_updated', true, {path: '/',domain: arNextOptions['MAIN_DOMAIN']});
                        location.href = url;
                    }
				});
				localStorage.removeItem('menu');
				localStorage.removeItem('menulifetime');
            })
        });

        this._initMobileCitySelect();

        if (this.showTooltip && this._isFirstVisit()) {
            $(this.root).on('show.bs.dropdown', () => {
                this.hideTooltip();
            });

            if (this.anotherCityBtn) {
                this.anotherCityBtn.addEventListener("click", (e) => {
                    e.stopPropagation();
                    this.hideTooltip();
					this.open();
					this.cityDropdownText.textContent = 'Выберите город'
					$(this.root).on('hide.bs.dropdown', () => {
						this.cityDropdownText.textContent = this.originCityDropdownText
					});
                });
            }

            this._showTooltip();

        } else if (this.showChooseCityList && this._isFirstVisit()) {
            if (!this.mobileMql.matches) {
                this.openMobile();
            } else {
				this.open();
				this.cityDropdownText.textContent = 'Выберите город'
				$(this.root).on('hide.bs.dropdown', () => {
					this.cityDropdownText.textContent = this.originCityDropdownText
				});
            }
        }
    }

    _showTooltip() {
        this.tooltip.classList.remove("is-hidden");
        this.mobileTooltip.classList.remove("is-hidden");
        this.tooltipShowed = true;
    }

	_initMobileCitySelect() {
        if (!this.mobileButton || !this.mobileTooltip || !this.confirmButton || !this.mobileConfirmButton) return;

        this.confirmButton.addEventListener("click", () => { this.hideTooltip(); });
        this.mobileConfirmButton.addEventListener("click", () => { this.hideTooltip(); });

        this.confirmButton.addEventListener("click", () => {
        	this.hideTooltip();
        	let cityId = this.confirmButton.dataset.id;
        	let url = this.confirmButton.dataset.url;
			$.ajax({
				type: "POST",
				url : arNextOptions['SITE_DIR'], //location.href,
				data: {city: cityId},
				success: function () {
					//console.log(location.href);
					//console.log(cityId);
					//console.log(url);
					location.href = url;
				}
			});

        });
        this.mobileConfirmButton.addEventListener("click", () => {
        	this.hideTooltip();
			let cityId = this.mobileConfirmButton.dataset.id;
			let url = this.mobileConfirmButton.dataset.url;
			$.ajax({
				type: "POST",
				url : arNextOptions['SITE_DIR'], //location.href,
				data: {city: cityId},
				success: function () {
					//console.log(location.href);
					//console.log(cityId);
					//console.log(url);
					//location.href = url;
					location.reload();
				}
			});
        });

		this.mobileButton.addEventListener("click", () => {
			this.openMobile();
            this.hideTooltip();
        })
    }

    _isFirstVisit() {
        return window.isFirstVisit; /* ($.cookie("first_visit_v2") === "true") ? true : false; */
    }

    _isCitySelected() {
        return !!$.cookie(CITY_SELECTED_COOKIE);
    }

    _setCitySelectedCookie() {
        $.cookie(CITY_SELECTED_COOKIE, "selected", { expires : CITY_SELECTED_COOKIE_EXPIRES, path: "/"});
    }

    openMobile() {
        $("#header .burger").click();
        $(".mobile_regions a.parent").click();
    }

    open() {
        if (this.dropDownToggle && !this.root.classList.contains("open")) {
            $(this.dropDownToggle).dropdown("toggle");
        }
    }

    hideTooltip() {
        this.tooltip.classList.add("is-hidden");
        this.mobileTooltip.classList.add("is-hidden");
        this.tooltipShowed = true;
    }
}
